// import React from "react";
// import axios from "axios";
// import Modal from "../../Other/Modal"; // Import the reusable Modal component

// const EnrollCourse = ({ isOpen, onClose, courseId,CourseName }) => {
//   if (!isOpen) return null;



//   const handleSubmit = async () => {
//     try {
//       const payload = {
//         courses: [courseId],
//         courseName:CourseName,
//       };

//       const token = JSON.parse(localStorage.getItem("token"));

//       await axios.post(
//         `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/cart?country=IN`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       await axios.post(
//         `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/checkout?country=IN`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       alert("Course enrolled successfully");
//       onClose();
//     } catch (error) {
//       console.error("Error enrolling in course:", error);
//       alert("Failed to enroll in course. Please try again.");
//     }
//   };

//   return (
//     <Modal isOpen={isOpen} onClose={onClose}>
//       <div className="p-5">
//         <h1 className="text-2xl font-semibold mb-6 text-center">
//           Do you want to enroll in this course?
//         </h1>
//         <div className="flex gap-4 justify-center">
//           <button
//             onClick={handleSubmit}
//             className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg"
//           >
//             Confirm
//           </button>
//           <button
//             onClick={onClose}
//             className="bg-gray-300 hover:bg-gray-400 text-black px-6 py-2 rounded-lg"
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     </Modal>
//   );
// };

// export default EnrollCourse;



import React from "react";
import axios from "axios";
import Modal from "../../Other/Modal"; 
import { useNavigate } from "react-router-dom";

const EnrollCourse = ({ isOpen, onClose, courseId, CourseName, EnrollFees }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSubmit = async () => {
    try {
      const payload = {
        courses: [courseId],
        courseName: CourseName,
      };

      const token = JSON.parse(localStorage.getItem("token"));

      if (EnrollFees === 0 || EnrollFees === 0.00 || EnrollFees === "0" || EnrollFees === "0.00") {
        await axios.post(
          `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/cart?country=IN`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        await axios.post(
          `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/checkout?country=IN`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        alert("Course enrolled successfully");
        onClose();
      } else {
        // Paid course: add to cart and redirect to checkout
        await axios.post(
          `${process.env.REACT_APP_LOGIN_API_BASEURL}/v2/cart?country=IN`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        onClose();
        navigate("/cart");
      }
    } catch (error) {
      console.error("Error enrolling in course:", error);
      alert("Failed to enroll in course. Please try again.");
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-0">
        <h1 className="text-2xl font-semibold mb-6 text-center mt-5">
          Do you want to enroll in this course?
        </h1>
        <div className="flex gap-4 justify-center">
          <button
            onClick={handleSubmit}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg"
          >
            Confirm
          </button>
          <button
            onClick={onClose}
            className="bg-gray-300 hover:bg-gray-400 text-black px-6 py-2 rounded-lg"
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EnrollCourse;
